import { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  TextField,
  Button,
  Typography,
  createTheme,
  Box,
  Link,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import AppAppBar2 from '../components/AppBar2';
import ProductHeroLayout from '../components/ProductHeroLayout';
import { minHeight, palette } from '@mui/system';
import { useFetchNoUser } from '../hooks/useFetchNoUser';
import CircularProgress from '@mui/material/CircularProgress';
import { useOnMount } from '@mui/x-data-grid/internals';

export default function Services() {
  const images = [
    '../img/Student2.jpg',
    '../img/Student6.jpg',
    '../img/Student4.jpg',
    '../img/Student3.jpg',
    '../img/Student5.jpg',
    '../img/Student1.jpg',
  ];

  const [backgroundImage, setBackgroundImage] = useState('../img/Student2.jpg');

  const navigate = useNavigate();

  return (
    <>
      <AppAppBar2 />
      <ProductHeroLayout
        fullWidth
        sxBackground={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundColor: '#7fc7d9', // Average color of the background image.
          fullWidth: '90vh',
          transition: 'background 3s linear',
        }}
      >
        <Box mb={7} />

        <Container
          maxWidth="lg"
          disableGutters
          align="center"
          top="50%"
          sx={{
            maxHeight: '90vh',
            overflow: 'scroll',
            backgroundColor: 'white',
            opacity: '0.8',
            border: 'Solid',
            borderWidth: '5px',
            borderColor: 'primary.main',
            padding: '30px',
            borderRadius: 3,
            marginTop: 3,
          }}
        >
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
            sx={{
              border: 'solid',
              borderWidth: '0px',
              borderColor: 'primary.main',
              borderRadius: 2,
            }}
          >
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="h3"
                  component="h3"
                  color="primary.main"
                  sx={{ textAlign: 'center' }}
                >
                  Information Guide
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="h6"
                  component="h6"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Services:
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  <b>Cambridge Examination Entry:</b> British International
                  College assists Private Exam Candidates to enter and write
                  Cambridge Examinations for IGCSE and A Level qualifications.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  <b>Academic Consultations:</b> Should you have any academic,
                  qualification, paper combination or general enquiry, Private
                  Exam Candidates can book a skype or face to face Academic
                  Consultation. Please note, consultations are booked at a
                  non-refundable fee.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  To purchases these services, please{' '}
                  <a href="./register">register</a> and login to our portal.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  British International College does <u>not</u> supply manual
                  quotes for Private Candidate Cambridge Examination
                  applications. All entries <u>must</u> be processed online.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="h6"
                  component="h6"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Registration and course material:
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Private Exam Candidates are not registered as British
                  International Colleges and Schools students.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Private Exam Candidates do not receive course material.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  <b>
                    If you require course material, please contact the College
                    to discuss fulltime or distance learning options on Tel:+27
                    11 706-7775
                  </b>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="h6"
                  component="h6"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Paper selection:
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  It is the responsibility of the Private Exam Candidate to
                  research their course and exam paper selections prior to
                  entering for examinations, in order to ensure they achieve
                  their desired result. If academic advice is required, an
                  academic consultation prior to entering for the examinations
                  can be arranged.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="h6"
                  component="h6"
                  color="primary.main"
                  sx={{ textAlign: 'center' }}
                >
                  Results:
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  All examinations are marked by Cambridge in the UK.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  No examination papers are returned by Cambridge.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Provisional results are released on results day.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Official Statement of Results are received 2 weeks after
                  results are released.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="h6"
                  component="h6"
                  color="primary.main"
                  sx={{ textAlign: 'center' }}
                >
                  Results breakdown:
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  <b>UNGRADED:</b> Indicates that the candidate's performance
                  fell short of the standard required for a Grade. The
                  qualification in that subject is therefore not achieved.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  <b>NO RESULT:</b> Indicates that a result cannot be issued
                  because of absence for the whole or part of the examination in
                  the syllabus or because of a Cambridge decision not to issue a
                  result for some other reason.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  <b>PENDING:</b> Indicates that a result cannot be issued at
                  present but will follow in due course.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Cambridge charges a substantial fee for Results Enquiries. A
                  breakdown of these fees and the procedure for Results Enquires
                  can be emailed upon request.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="h6"
                  component="h6"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Certificates:
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Original Certificates are only received from Cambridge 3
                  months after the close of an exam session.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Certificates can be collected from the Exams Office at the
                  Bryanston campus. An email request needs to be sent to{' '}
                  <a href="mailto:privatecandidates@bicollege.co.za">
                    privatecandidates@bicollege.co.za
                  </a>{' '}
                  and Certificates will be made available 48hrs after receiving
                  the request.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Couriering of certificates is at the cost of the person
                  requesting the courier
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="h6"
                  component="h6"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Fees and Penalties:
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Candidate entry fees, penalty fees and all administrative fees
                  are non-refundable.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Cambridge examination fees are only refunded once Cambridge
                  have issued the refund at the end of each examination session.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Penalties are based on application date.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Penalties will not be waivered regardless of the
                  circumstances.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  We are not associated with British Council South Africa. We
                  are a fully registered Cambridge Examination Centre in our own
                  right and may have different entry dates and penalty fees.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Cambridge examination entries, Topic Tutorials and
                  consultations bookings are only processed once online payment
                  has been completed.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="h6"
                  component="h6"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Special Arrangements / Concessions:
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Should you require special exam arrangements (such as
                  additional time or exam equipment and etc.), then you will
                  need to request a quotation from the Private Candidate Team.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  An email listing the examinations you wish to write
                  accompanies with a Doctor’s note or Psychologists report
                  requesting the special arrangements will need to be sent to{' '}
                  <a href="mailto:privatecandidates@bicollege.co.za">
                    privatecandidates@bicollege.co.za
                  </a>
                  .
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  The request will then be sent to Cambridge for decision.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  In the event you are granted the special arrangement, a
                  quotation for these special arrangements will be sent to you.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  These services incur additional charges from the standard
                  entry.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Additional charges will need to be settled before the
                  concessions is inplace.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Payments need to be made by 30 April for the May/June and by
                  30 September for the October/November exam session.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Cambridge requires an application be completed prior to{' '}
                  <b>each</b> exam session.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Cambridge requires an application be completed prior to{' '}
                  <b>each</b> exam session.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="h6"
                  component="h6"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  Technical Stuff:
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="left"
                alignItems="left"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography
                  variant="body2"
                  component="p"
                  color="primary.main"
                  sx={{ textAlign: 'left' }}
                >
                  This website uses JavaScript and Cookies. For best results
                  with this website, we recommend using an updated version of{' '}
                  <b>Google Chrome</b> or <b>Mozilla Firefox</b>. Other browser
                  will vary in performance and compatibility.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </ProductHeroLayout>
    </>
  );
}
